import { Commit } from 'vuex';
import { FactureFournisseurState } from '.';

export interface FactureFournisseurActionType {
    commit: Commit;
    state: FactureFournisseurState;
    getters: any;
}

export enum FactureFournisseurActions {
    GET_FACTURES = 'GET_FACTURES',
    CONTACTER = 'CONTACTER',
    GET_XLS = 'GET_XLS'
}
